<template>
	<div class="box">
		<el-dialog width="300px" title="扫码支付" :visible="show" @close="closeCode" append-to-body>
			<div class="paycode">
				<!-- 放置二维码的容器,需要给一个ref -->
				<!-- <div id="qrcode" ref="qrcode"></div> -->
				<vue-qr style="display: inline-block;margin-left: 30px;
				" :logoSrc="imageUrl" :text="Text" :size="200"></vue-qr>
				<!-- poidsa: 后台接口返回的form 片段 -->
				<div>支付完成后，关闭重新进入</div>
			</div>
		</el-dialog>
		<div class="popContainer" v-if="isShowZF">
			<!-- 支付窗口 -->
			<div class="zf_warp">
				<!-- 关闭 -->
				<div class="gb_sqewm" @click="gb_ZF">
					<img src="../../imges/dashang/gbX.png">
				</div>
				<div class="ZF_title" v-if="sfxs">
					打赏
				</div>
				<div class="ZF_title" v-else>
					充值
				</div>
				<div class="dsje_warp" style="height: 50px;">
					<div class="dsje_title" v-if="sfxs">打赏金额：</div>
					<div class="dsje_title" v-else>充值金额：</div>
					<div class="dsjr_je" v-if="price == 0">
						<div :class="{color_style: this.xzzfs == 1}" @click="GB_je(1,'5')">￥5
							<div class="xz" v-show="this.xzzfs == 1"><img src="../../imges/dashang/xz_img.png"></div>
						</div>
						<div :class="{color_style:this.xzzfs == 2}" @click="GB_je(2,'10')">￥10
							<div class="xz" v-show="this.xzzfs == 2"><img src="../../imges/dashang/xz_img.png"></div>
						</div>
						<div :class="{color_style:this.xzzfs == 3}" @click="GB_je(3,'30')">￥30
							<div class="xz" v-show="this.xzzfs == 3"><img src="../../imges/dashang/xz_img.png"></div>
						</div>
						<div :class="{color_style:this.xzzfs == 4}" @click="GB_je(4,'50')">￥50
							<div class="xz" v-show="this.xzzfs == 4"><img src="../../imges/dashang/xz_img.png"></div>
						</div>
					</div>
					<div v-else>{{price}}元</div>
				</div>
				<div class="dsje_warp" v-if="price == 0" style="height: 50px;">
					<div class="dsje_title">其他金额：</div>
					<div class="qtjr_je">
						<div class="input_sty">
							<el-input v-model="amounts" placeholder="请输入金额" @blur="qtje_xz(amounts)"></el-input>
						</div>
						<div class="txbz_sty">
							<el-input v-model="bza" placeholder="填写备注"></el-input>
						</div>
					</div>
				</div>
				<div class="zffs_warp" style="height: 50px;">
					<div class="dsje_title">支付方式：</div>
					<div class="zffs_je">
						<div :class="{color_style: this.zffs == 1}" @click="GB_zffs(1)">
							<div class="zf_img">
								<img src="../../imges/dashang/wxzf.png">
							</div>
							<div class="xz" v-show="this.zffs == 1"><img src="../../imges/dashang/xz_img.png"></div>
						</div>
						<div :class="{color_style:this.zffs == 2}" @click="GB_zffs(2)">
							<div class="zf_img">
								<img src="../../imges/dashang/zfbzf.png">
							</div>
							<div class="xz" v-show="this.zffs == 2"><img src="../../imges/dashang/xz_img.png"></div>
						</div>
						<div :class="{color_style:this.zffs == 3}" @click="GB_zffs(3)" v-if="sfxs">
							<div class="zf_img">
								余额打赏
							</div>
							<div class="xz" v-show="this.zffs == 3"><img src="../../imges/dashang/xz_img.png"></div>
						</div>
					</div>
				</div>
				<div class="dsje_warp" style="margin-top:20px;">
					<div class="dsje_title"> </div>
					<div class="qtjr_je">
						<div @click="payOrder" class="txbz_sty" v-if="sfxs"
							style="cursor: pointer;letter-spacing: 2px;margin-left:70px;background:#ff4400;color:#fff;font-size:16px;font-weight:600;">
							立即打赏</div>
							<div @click="payOrder" class="txbz_sty" v-else
								style="cursor: pointer;letter-spacing: 2px;margin-left:70px;background:#ff4400;color:#fff;font-size:16px;font-weight:600;">
								立即充值</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import QRCode from 'qrcodejs2'
	import vueQr from 'vue-qr'
	import http from "@/utils/http";
	export default {
		components: {
			QRCode,
			vueQr
		},
		props: {
			dsje: {},
		},
		data() {
			return {
				imageUrl: 'https://img1.baidu.com/it/u=3311948344,2093308219&fm=253&fmt=auto&app=138&f=PNG?w=500&h=500',
				zffs: '',
				isShowZF: false,
				xzzf: '',
				xzzfs: '',
				price: 0,
				name: '',
				tid: 0,
				nologin_type: '',
				amounts: '', //其他金额
				bza: '',
				poidsa: '',
				show: false,
				qr: '',
				Text: '',
				sfxs:true,
			}
		},
		methods: {
			GB_zffs(val) {
				this.zffs = val
			},
			deff(a) {
				console.log(a)
			},
			qtje_xz(val) {
				this.xzzf = val
			},
			//金额选中
			GB_je(val, val1) {
				this.xzzf = val1
				this.xzzfs = val
				console.log(this.xzzf)
			},
			async isfufei(nologin_type, tid){
				let loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				if (loginInfo) {
					let ff =  await http.post('api/picture/login_yz', {
						tid: tid,
						nologin_type: nologin_type,
						uid: loginInfo.id
					})
					if (ff.data.code == 200) {
						this.$message.error('已付费');
						return false;
					}
				}else{
					return false;
				}
			},
			//支付
			DS_ck(price = 0, name, nologin_type, tid) {
				console.log(price, name, nologin_type, tid)
				if(nologin_type == 'cz'){
					this.sfxs = false
					this.price = price;
					this.nologin_type = nologin_type;
					this.name = name;
					this.tid = tid;
					this.isShowZF = true;
				}else{
					let loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
					if (loginInfo) {
						http.post('api/picture/login_yz', {
							tid: tid,
							nologin_type: nologin_type,
							uid: loginInfo.id
						}).then(res => {
							console.log(res)
							if (res.data.code == 200) {
								this.$message.error('已付费');
								return false;
							}else{
								this.price = price;
								this.nologin_type = nologin_type;
								this.name = name;
								this.tid = tid;
								this.isShowZF = true;
							}
						})
						
					}else{
						this.$message.error('请登录在查看哦');
						this.$router.push('/')
						return false;
					}
				}
				
				
				
			},
			//关闭支付
			gb_ZF() {
				this.isShowZF = false;
				// if (this.isShowZF == false) {
				// 	this.$confirm('是否充值完成？', '提示', {
				// 		confirmButtonText: '确定',
				// 		cancelButtonText: '取消',
				// 		type: 'warning'
				// 	}).then(() => {
				// 		console.log('1')
				// 		this.$router.go(0)
				// 	}).catch(() => {
				// 		console.log('2')
				// 	});
				// }
				// console.log('3')
			},
			// 关闭弹框,清除已经生成的二维码
			closeCode() {
				this.show = false;
				this.$router.go(0)
				// if (this.show == false) {
				// 	this.$confirm('是否充值完成？', '提示', {
				// 		confirmButtonText: '确定',
				// 		cancelButtonText: '取消',
				// 		type: 'warning'
				// 	}).then(() => {
				// 		console.log('1')
				// 		this.$router.go(0)
				// 	}).catch(() => {
				// 		console.log('2')
				// 	});
				// }
				// this.$refs.qrcode.innerHTML = "";
			},
			// 展示二维码
			payOrder() {
				// console.log(this.dsje)
				const loginInfo = JSON.parse(window.sessionStorage.getItem('token') || null)
				if (loginInfo == null) {
					this.$message.error('请登录');
					return false;
				} else {
					if (this.zffs == 1) {
						this.qwqertyu1()
					} else if (this.zffs == 2) {
						this.qwqertyu()
					} else if (this.zffs == 3) {
						this.qwqertyu3()
					}
				}
			},
		
			async qwqertyu() {
				const loginInfos = JSON.parse(window.sessionStorage.getItem('user') || null)
				if (loginInfos) {
					// let res = await http.get('api/picture/apipay', {
					// 	WIDsubject: this.name,
					// 	WIDtotal_amount: this.price ? this.price : this.xzzf,
					// 	uid: loginInfos.id,
					// 	tid: this.tid,
					// 	WIDbody: this.bza,
					// 	nologin_type: this.nologin_type
					// })
					let res = await http.get('api/picture/apipay', {
						WIDsubject: '支付宝充值订单',
						WIDtotal_amount: this.price ? this.price : this.xzzf,
						type: '2',
						WIDbody: this.bza,
						uid: loginInfos.id,
					})
					let routerData = this.$router.resolve({
						path: '/zfa',
						query: {
							htmlData: res.data
						}
					})
					// 打开新页面
					window.open(routerData.href, '_ blank')
				} else {
					this.$router.push('/login')
				}
			},
			async qwqertyu1() {
				let that = this;
				const loginInfos = JSON.parse(window.sessionStorage.getItem('user') || null)
				if (loginInfos) {
					// let res = await http.get('api/picture/wxpay', {
					// 	SetBody: this.name,
					// 	SetTotal_fee: this.price ? this.price : this.xzzf,
					// 	uid: loginInfos.id,
					// 	tid: this.tid,
					// 	nologin_type: this.nologin_type
					// })
					let res = await http.get('api/picture/wxpay', {
						SetBody: '微信充值订单',
						SetTotal_fee: this.price ? this.price : this.xzzf,
						uid: loginInfos.id,
						type: '2',
					})
					console.log(res)
					that.show = true;
					that.Text = res.data.data
					that.isShowZF = false
					// this.$router.go(0)
				} else {
					this.$router.push('/login')
				}
			},
			// 生成二维码
			crateQrcode() {
				this.qr = new QRCode("qrcode", {
					width: 130,
					height: 130, // 高度
					text: this.qrcode, // 二维码内容
					background: "#f0f"
				});
			},
			dschenggong(uid, money) {
				const loginInfos = JSON.parse(window.sessionStorage.getItem('user') || null)
				this.$axios({
					url: 'https://admin.shipoe360.com/api/picture/dschenggong',
					method: 'post',
					params: {
						uid: loginInfos.id,
						money: money
					}
				}).then(res => {
					console.log(res)
					alert(res.data.msg)
				})
			},
			async qwqertyu3() {
				const loginInfos = JSON.parse(window.sessionStorage.getItem('user') || null)
				console.log(this.dsje)
				if (loginInfos) {
					let res = await http.get('api/picture/yuedashang', {
						SetBody: this.name,
						SetTotal_fee: this.price ? this.price : this.xzzf,
						uid: loginInfos.id,
						tid: this.tid,
						nologin_type: this.nologin_type
					})
					console.log(res)

					if (res.data.code == 200) {
						this.dschenggong(this.detailData.uid, this.xzzf);
					}
					alert(res.data.msg)
					location.reload();
				} else {
					this.$router.push('/login')
				}
			},
		},
	}
</script>

<style scoped>
	.popContainer {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 9999;
		background: rgba(0, 0, 0, 0.6);
	}

	.zf_warp {
		position: absolute;
		top: 20%;
		left: 50%;
		margin-left: -300px;
		width: 600px;
		background-color: #fff;
		padding-bottom: 30px;
	}


	.gb_sqewm {
		position: absolute;
		top: 10px;
		right: 10px;
		cursor: pointer;
		width: 20px;
		height: 20px;
		background-color: #a0bdd8;
	}

	.ZF_title {
		background-color: #a0bdd8;
		height: 40px;
		line-height: 40px;
		font-size: 16px;
		font-weight: 600;
		letter-spacing: 4px;
		padding-left: 18px;
	}

	.dsje_warp {
		margin-left: 20px;
		margin-top: 12px;
	}

	.color_style {
		border: 1px solid #ff4400 !important;
	}

	.dsje_title {
		float: left;
		font-size: 14px;
	}

	.dsjr_je {
		float: left;
		margin-left: 20px;
	}

	.dsjr_je>div {
		position: relative;
		float: left;
		height: 45px;
		width: 80px;
		text-align: center;
		line-height: 45px;
		margin-left: 20px;
		cursor: pointer;

	}

	.dsjr_je>div>div {
		height: 20px;
		width: 20px;
		position: absolute;
		bottom: 9px;
		right: -1px;
	}

	.dsjr_je>div>div>img {
		width: 100%;
		height: 100%;
	}

	.qtjr_je {
		float: left;
		margin-left: 40px;
	}

	.input_sty {
		float: left;
		width: 200px;
	}

	.txbz_sty {
		float: left;
		width: 140px;
		margin-left: 20px;
		height: 40px;
		line-height: 40px;
		text-align: center;
		color: #257beb;
	}

	.zffs_warp {
		margin-left: 20px;
		margin-top: 12px;
	}

	.color_style {
		border: 1px solid #ff4400 !important;
	}

	.dsje_title {
		float: left;
		font-size: 14px;
	}

	.zffs_je {
		float: left;
		margin-left: 20px;
	}

	.zffs_je>div {
		position: relative;
		float: left;
		height: 45px;
		width: 120px;
		text-align: center;
		line-height: 45px;
		border: 1px solid #c0bfbf;
		margin-left: 20px;
		overflow: hidden;
		cursor: pointer;
	}

	.gb_sqewm>img {
		width: 100%;
		height: 100%;
	}

	.xz {
		height: 20px;
		width: 20px;
		position: absolute;
		bottom: 9px;
		right: -2px;
	}

	.xz>img {
		width: 100%;
		height: 100%;
	}

	.zf_img {
		margin-top: -3px;
		height: 40px;
		margin-left: 10px;
		width: 90px;
		overflow: hidden;
	}

	.zf_img>img {
		width: 100%;
		height: 100%;
	}

	.qtjr_je {
		float: left;
		margin-left: 40px;
	}

	.input_sty {
		float: left;
		width: 200px;
	}

	.txbz_sty {
		float: left;
		width: 140px;
		margin-left: 20px;
		border: 1px solid #97c7f3;
		height: 40px;
		line-height: 40px;
		text-align: center;
		color: #257beb;
	}
</style>
